class CardButtonsComponent extends HTMLElement {
  connectedCallback() {
    this.innerHTML = String.raw`
      <div class="row hidden-print mt-3" style="max-width: 900px;">
        <!-- Material Selector -->
        <div class="col-lg-4 col-xs-4">
          <a href="#" data-bs-toggle="modal" data-bs-target="#modal-material-dialog">
            <div class="card card-primary card-shadow text-center">
              <div id="material-panel-text" class="card-header" style="font-size: 18px;">Steel A992</div>
              <div class="card-body hidden-print">
                <span class="float-start">Change material...</span>
                <span class="float-end hidden-md hidden-sm hidden-xs"><i class="fa fa-edit"></i></span>
              </div>
            </div>
          </a>
        </div>

        <!-- Shape Selector -->
        <div class="col-lg-4 col-xs-4">
          <a href="#" data-bs-toggle="modal" data-bs-target="#modal-shape-dialog">
            <div class="card card-primary card-shadow text-center">
              <div id="shape-panel-text" class="card-header" style="font-size: 18px;">W8X15 (48 in<sup>4</sup>)</div>
              <div class="card-body hidden-print">
                <span class="float-start">Change shape...</span>
                <span class="float-end hidden-md hidden-sm hidden-xs"><i class="fa fa-edit"></i></span>
              </div>
            </div>
          </a>
        </div>

        <!-- Design Selector -->
        <div class="col-lg-4 col-xs-4">
          <a href="#" data-bs-toggle="modal" data-bs-target="#modal-design-dialog">
            <div class="card card-primary card-shadow text-center">
              <div id="design-panel-text" class="card-header" style="font-size: 18px;">AISC Steel LRFD</div>
              <div class="card-body hidden-print">
                <span class="float-start">Change design spec...</span>
                <span class="float-end hidden-md hidden-sm hidden-xs"><i class="fa fa-edit"></i></span>
              </div>
            </div>
          </a>
        </div>
      </div>
      <!-- /.row -->

      <div class="row hidden-print mt-3" style="max-width: 900px;">

        <!-- Span Selector -->
        <div class="col-lg-4 col-xs-4">
          <a href="#" data-bs-toggle="modal" data-bs-target="#modal-span-dialog">
            <div class="card card-primary card-shadow text-center">
              <div id="span-panel-text" class="card-header" style="font-size: 18px;">2 Spans</div>
              <div class="card-body hidden-print">
                <span class="float-start">Add or remove spans...</span>
                <span class="float-end hidden-md hidden-sm hidden-xs"><i class="fa fa-edit"></i></span>
              </div>
            </div>
          </a>
        </div>

        <!-- Loads Selector -->
        <div class="col-lg-4 col-xs-4">
          <a href="#" data-bs-toggle="modal" data-bs-target="#modal-load-dialog">
            <div class="card card-primary card-shadow text-center">
              <div id="load-panel-text" class="card-header" style="font-size: 18px;">2 Loads</div>
              <div class="card-body hidden-print">
                <span class="float-start">Edit loads...</span>
                <span class="float-end hidden-md hidden-sm hidden-xs"><i class="fa fa-edit"></i></span>
              </div>
            </div>
          </a>
        </div>

        <!-- Bracing Selector -->
        <div class="col-lg-4 col-xs-4">
          <a href="#" data-bs-toggle="modal" data-bs-target="#modal-bracing-dialog">
            <div class="card card-primary card-shadow text-center">
              <div id="bracing-button-text" class="card-header" style="font-size: 18px;">Continuous Bracing</div>
              <div class="card-body hidden-print">
                <span class="float-start">Change bracing...</span>
                <span class="float-end hidden-md hidden-sm hidden-xs"><i class="fa fa-edit"></i></span>
              </div>
            </div>
          </a>
        </div>
      </div>
      <!-- /.row -->
      `
  }
}

customElements.define('card-buttons', CardButtonsComponent);